import React from "react";
import ClientRoutes from "../../../navigation/Routes";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { editDetails } from "../../../store/reducers/authReducer";
import { toast } from "react-toastify";

/** עיצוב נקי ונייטרלי — ללא גרדיאנטים וצבעים חזקים */
const palette = {
  text: "#27272a",
  textMuted: "#71717a",
  border: "#e4e4e7",
  footerBg: "#fafafa",
  cardBg: "#ffffff",
  primaryBtn: "#3f3f46",
};

const btnBase = {
  fontFamily: "hebM, system-ui, sans-serif",
  fontSize: 15,
  fontWeight: 600,
  padding: "13px 18px",
  borderRadius: 10,
  cursor: "pointer",
  textAlign: "center",
  lineHeight: 1.35,
  transition:
    "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
  minHeight: 46,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const CanWeStart = ({ init }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer);
  const role = user?.role;

  const handleSetIsReady = () => {
    dispatch(editDetails({ isReady: true })).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init(false);
      } else toast.error(res.payload?.error);
    });
  };

  const handleGoInstruction = () => {
    init(false);
    history.push(ClientRoutes.User.instruction);
  };

  const renderRoleBody = () => {
    if (role === 1) {
      return (
        <p
          style={{
            margin: 0,
            fontSize: 15,
            lineHeight: 1.75,
            color: palette.text,
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          מומלץ להקטין ראש 😉, אין צורך לנסות להבין את המערכת — שלחו לשירות
          הלקוחות אקסל + הזמנה עד חודש לפני האירוע ותנו לנו להוביל את התהליך
          בצורה הכי נכונה עבורכם 🙏
        </p>
      );
    }
    if (role === 5 || role === 6) {
      return (
        <>
          <p
            style={{
              margin: 0,
              fontSize: 15,
              lineHeight: 1.75,
              color: palette.text,
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            על מנת שהמערכת תהיה מוכנה לתחילת העבודה נדרש להיכנס לעמוד ההדרכות על
            מנת לצפות ולבצע את סרטוני החובה.
          </p>
          <button
            type="button"
            onClick={handleGoInstruction}
            style={{
              ...btnBase,
              marginTop: 14,
              width: "100%",
              background: palette.cardBg,
              color: palette.text,
              border: `1px solid ${palette.border}`,
            }}
          >
            מעבר לעמוד ההדרכות
          </button>
        </>
      );
    }
    return (
      <p
        style={{
          margin: 0,
          fontSize: 15,
          lineHeight: 1.75,
          color: palette.text,
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        לפני שתאשרו התחלה במערכת, ודאו שכל האורחים הוזנו, שלחתם את החומרים
        הנדרשים לשירות הלקוחות, והשלמתם את ההדרכות לפי הנחיות הצוות.
      </p>
    );
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "min(100%, 440px)",
        maxWidth: "100%",
        margin: 0,
        padding: "12px 16px",
        boxSizing: "border-box",
        direction: "rtl",
      }}
    >
      <div
        style={{
          borderRadius: 12,
          background: palette.cardBg,
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.08)",
          border: `1px solid ${palette.border}`,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "20px 22px 12px",
            borderBottom: `1px solid ${palette.border}`,
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: 17,
              fontWeight: 600,
              color: palette.text,
              textAlign: "center",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            שימו לב
          </h2>
        </div>

        <div style={{ padding: "20px 22px 6px" }}>{renderRoleBody()}</div>

        <div style={{ padding: "6px 22px 18px" }}>
          <p
            style={{
              margin: 0,
              marginTop: "10px",
              fontSize: 15,
              fontWeight: 600,
              lineHeight: 1.55,
              color: palette.text,
              textAlign: "center",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            אנא היצמדו ללו״ז כדי שנעבור תהליך מסודר ונעים
          </p>
        </div>

        <div
          style={{
            padding: "16px 18px 18px",
            background: palette.footerBg,
            borderTop: `1px solid ${palette.border}`,
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <button
            type="button"
            onClick={handleSetIsReady}
            style={{
              ...btnBase,
              width: "100%",
              background: palette.primaryBtn,
              background: "rgb(56, 87, 144)",
              color: "#fafafa",
              border: `1px solid ${palette.primaryBtn}`,
            }}
          >
            עשינו הכל אפשר להתחיל
          </button>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              justifyContent: "stretch",
            }}
          >
            <button
              type="button"
              onClick={() => init(false)}
              style={{
                ...btnBase,
                flex: "1 1 140px",
                background: palette.cardBg,
                color: palette.textMuted,
                border: `1px solid ${palette.border}`,
              }}
            >
              עוד לא מוכן
            </button>
            <button
              type="button"
              onClick={() => history.push(ClientRoutes.User.todos)}
              style={{
                ...btnBase,
                flex: "1 1 140px",
                background: palette.cardBg,
                color: palette.text,
                border: `1px solid ${palette.border}`,
              }}
            >
              מעבר ללו״ז
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanWeStart;
